import axios from "axios";

const API_URL =
  !process.env.NEXT_PUBLIC_CONFIGURATION ||
  process.env.NEXT_PUBLIC_CONFIGURATION !== "production"
    ? "https://api.dev.yolk.coach"
    : "https://api.yolk.coach";

/**
 * Public Client Fetcher - For unauthenticated API requests
 *
 * Unlike @workspace/api/client-fetcher, this does NOT include
 * NextAuth interceptor or Authorization headers.
 *
 * Used for public endpoints like:
 * - POST /public/training-sessions
 * - GET /public/training-sessions/{id}
 * - POST /public/training-sessions/{id}/complete
 */
export const publicClientFetcher = axios.create({
  baseURL: API_URL,
});

publicClientFetcher.interceptors.request.use((config) => {
  if (!(config.data instanceof FormData)) {
    config.headers.set("Content-Type", "application/json");
  }
  config.headers.set("Accept", "application/json");
  return config;
});
